import { render, staticRenderFns } from "./naj-confirmation-with-submessage.vue?vue&type=template&id=4ae743f9&scoped=true&"
import script from "./naj-confirmation-with-submessage.vue?vue&type=script&lang=js&"
export * from "./naj-confirmation-with-submessage.vue?vue&type=script&lang=js&"
import style0 from "./naj-confirmation-with-submessage.vue?vue&type=style&index=0&id=4ae743f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae743f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
